import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AccountSettingsV2Service } from "@m19-board/services/account-settings.service";
import { map, take } from "rxjs";

export const accountsSettingsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const accountSettingsService = inject(AccountSettingsV2Service);

  return accountSettingsService.organizationsToDisplay$.pipe(
    take(1),
    map((orgs) => {
      if (orgs.length === 1) {
        const orgId = orgs[0].organization.organizationId;
        return router.createUrlTree([`/accounts/${orgId}`]);
      }
      return true;
    }),
  );
};
